import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';
import {EmailDeliveryLog} from 'src/openapi/admin/models/EmailDeliveryLog';

import {UserEmailLogsCriteria} from '../typedef';

import {userEmailDeliveryLogStateSelector} from './user-email-delivery-log-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';

export const userEmailDeliveryLogSlice = getCachedTableDataSlice<
    EmailDeliveryLog[],
    undefined,
    undefined,
    UserEmailLogsCriteria
>('userEmailDeliveryLog');

export const userEmailDeliveryLogActions = userEmailDeliveryLogSlice.actions;
const userEmailDeliveryLogCacheSelector: CachedTableCacheSelector<EmailDeliveryLog[]>
    = state => state.userPage.tabs.loginAndPassword.events.cache;
export const userEmailDeliveryLogDataSelector: CachedTableDataSelector<EmailDeliveryLog[]>
    = state => state.userPage.tabs.loginAndPassword.events;
export const userEmailDeliveryLogResultSelector = getCachedTableResultSelector(
    userEmailDeliveryLogCacheSelector,
    userEmailDeliveryLogStateSelector,
);
